module.exports = __webpack_public_path__ + "static/media/man.540cba29.png";